/**
 * OOTBS SFRA JS code
 * Changed wishlist type toggle event
 * Copied selectSizeAttribute OOTB method
 */
'use strict';

const { queryFirst, queryAll, addClass, removeClass, hasClass, scrollTo } = require('../domUtil');
const { getJSON, appendToUrl, getNestedValue } = require('../util');
const { guestEmptyWishlistTemplate } = require('../templates');
const { WISHLIST_NAME_REGEX } = require('../components/shippingPreference/constants');
const { toggleSelectSizeInfo } = require('../product/helper');

import base from '../product/base';
import { trackWishlist } from '../components/etmc';
var focusHelper = require('base/components/focus');
const invalidClass = 'is-invalid';
const selectedClass = 'selected';
const $body = $('body');
const $wishlist = $('.wishlist-section');
const hiddenClass = 'd-none';
const createWishlistDialog = queryFirst('.create-wishlist-dialog');
const editWishlistDialog = queryFirst('.edit-wishlist-dialog');
const shareWishlistDialog = queryFirst('.share-wishlist-dialog');
const editWishlistDialogContent = queryFirst('.edit-wishlist-name-body', editWishlistDialog);
const deleteWishlistDialogContent = queryFirst('.delete-wishlist-name-body', editWishlistDialog);
const isMcEnable = $('#mcEnableAnalytics').val();

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    if (!response.error) {
        return;
    }
    var messageType = response.error ? 'alert-danger' : 'alert-success';

    if ($('.add-to-cart-messages').length === 0) {
        $body.append('<div class="add-to-cart-messages"></div>');
    }

    $('.add-to-cart-messages').append(
        '<div class="alert ' +
        messageType +
        ' add-to-basket-alert text-center" role="alert">' +
        response.message +
        '</div>'
    );

    setTimeout(function () {
        $('.add-to-basket-alert').remove();
    }, 5000);
}

/**
 * updates the Wishlist product view when a product attribute is selected 
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $wishListContainer - DOM element for current wishlisted product
 * @param {Object} selectedSizeElement - DOM element for selected size button
 */
function wishListAttributeSelect(selectedValueUrl, $wishListContainer, selectedSizeElement) {
    if (selectedValueUrl) {
        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                $body.trigger('product:afterAttributeSelect', {
                    data: data,
                    container: $wishListContainer,
                    selectedSizeElement
                });
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}
/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    var htmlString =
        '<!-- Modal -->' +
        '<div class="modal fade" id="editWishlistProductModal" tabindex="-1" role="dialog">' +
        '<span class="enter-message sr-only" ></span>' +
        '<div class="modal-dialog quick-view-dialog">' +
        '<!-- Modal content-->' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        '    <button type="button" class="close pull-right" data-dismiss="modal">' +
        '        <span aria-hidden="true">&times;</span>' +
        '        <span class="sr-only"> </span>' +
        '    </button>' +
        '</div>' +
        '<div class="modal-body"></div>' +
        '<div class="modal-footer"></div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $body.append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
    $('#editWishlistProductModal')
        .spinner()
        .start();

    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);
            $('#editWishlistProductModal .modal-body').empty();
            $('#editWishlistProductModal .modal-body').html(parsedHtml.body);
            $('#editWishlistProductModal .modal-footer').html(parsedHtml.footer);
            $('#editWishlistProductModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#editWishlistProductModal .enter-message').text(data.enterDialogMessage);
            $('#editWishlistProductModal').modal('show');
            $body.trigger('editwishlistproduct:ready');
            $.spinner().stop();
        },
        error: function () {
            $('#editWishlistProductModal').spinner().stop();
        }
    });
}

/**
 * show toast response
 * @param {Object} res - from the call to set the public status of a list or item in a list
 */
function showResponseMsg(res) {
    $.spinner().stop();
    var status;

    if (res.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.add-to-wishlist-messages').length === 0) {
        $body.append('<div class="add-to-wishlist-messages "></div>');
    }

    $('.add-to-wishlist-messages').append('<div class="add-to-wishlist-alert text-center ' + status + '">' + res.msg + '</div>');

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
    }, 3000);
}

/**
 * toggles the public / private status of the item or wishlist item
 * @param {string} listID - the order model
 * @param {string} itemID - the customer model
 * @param {Object} callback - function to run if the ajax call returns with an
 *                        error so that the checkbox can be reset to it's original state
 */
function updatePublicStatus(listID, itemID, callback) {
    var url = $('.wishlist-type').data('url');
    $.spinner().start();
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: {
            listID: listID,
            itemID: itemID
        },
        success: function (data) {
            if (callback && !data.success) {
                callback();
            }
            // LP customization start
            const isWishlistPublic = queryFirst('input[name="wishlist-setting"]').checked;
            const wishlistSettingsInfo = queryFirst('.wishlist-settings-info');
            if (!isWishlistPublic) {
                addClass(queryAll('.wishlist-share-' + listID), hiddenClass);
                addClass(queryFirst('.wishlist-public-msg', wishlistSettingsInfo), hiddenClass);
                removeClass(queryFirst('.wishlist-private-msg', wishlistSettingsInfo), hiddenClass);
            } else {
                removeClass(queryAll('.wishlist-share-' + listID), hiddenClass);
                removeClass(queryFirst('.wishlist-public-msg', wishlistSettingsInfo), hiddenClass);
                addClass(queryFirst('.wishlist-private-msg', wishlistSettingsInfo), hiddenClass);
                const wishlistShareBtn = queryFirst('.wishlist-share.wishlist-share-' + listID);
                const shareListBtn = queryFirst('.share-list', wishlistShareBtn);
                shareListBtn.dataset.shareUrl = data.shareUrl;
            }
            // LP customization end
            showResponseMsg(data, null);
        },
        error: function (err) {
            if (callback) {
                callback();
            }
            showResponseMsg(err);
        }
    });
}
/**
 * @param {Object} $elementAppendTo - The element to append error html to
 * @param {string} msg - The error message
 * display error message if remove item from wishlist failed
 */
function displayErrorMessage($elementAppendTo, msg) {
    if ($('.remove-from-wishlist-messages').length === 0) {
        $elementAppendTo.append('<div class="remove-from-wishlist-messages "></div>');
    }
    $('.remove-from-wishlist-messages')
        .append('<div class="remove-from-wishlist-alert text-center alert-danger">' + msg + '</div>');

    setTimeout(function () {
        $('.remove-from-wishlist-messages').remove();
    }, 3000);
}
/**
 * Show the Fit Size Tab if fit size selectable count is greater than one
 */
function updateFitSizeTab() {
    const fitSizeSelectableCountEle = queryAll('.selectableCount');
    fitSizeSelectableCountEle.forEach(fitSizeSelectableCount => {
        const fitSizeSelectWishListContainer = fitSizeSelectableCount.closest('.fit-size-card');
        if (fitSizeSelectableCount) {
            const fitSizeCount = fitSizeSelectableCount.dataset.selectableCount;
            if (fitSizeCount > 1) {
                removeClass(fitSizeSelectWishListContainer, 'd-none');
            }
        }
    });

}

/**
 * renders the list up to a given page number
 * @param {number} pageNumber - current page number
 * @param {string} focusElementSelector - selector of the element to focus on
 */
function renderNewPageOfItems(pageNumber, focusElementSelector) {
    var publicView = $('.wishlistItemCardsData').data('public-view');
    var listUUID = $('.wishlistItemCardsData').data('uuid');
    var url = $('.wishlistItemCardsData').data('href');
    var scrollPosition = document.documentElement.scrollTop;
    const countBeforeShowMore = $('.wishlist-card-item').length;
    $.ajax({
        url: url,
        method: 'get',
        data: {
            pageNumber,
            publicView: publicView,
            id: listUUID
        }
    })
        .done(function (data) {
            $('.wishlistItemCardsWrapper').empty();
            $('body .wishlistItemCardsWrapper').replaceWith(data);
            const countAfterShowMore = $('.wishlist-card-item').length;
            let focusElementIndex = 1;
            if (countBeforeShowMore === countAfterShowMore) {
                focusElementIndex = countAfterShowMore;
            } else {
                focusElementIndex = countBeforeShowMore + 1;
            }
            const focusElement = $('.wishlist-card-item:nth-child(' + focusElementIndex + ') .wishlist-img-link');
            if (focusElementSelector) {
                $(focusElementSelector).focus();
            } else if (focusElement) {
                focusElement.focus();
            } else {
                document.documentElement.scrollTop = scrollPosition;
            }
            $.spinner().stop();
        })
        .fail(function () {
            $('.more-wishlist-items').remove();
            $.spinner().stop();
        });
}

/**
 * This method handles wishlist search results
 */
function handleSearchResults(data) {
    let searchResultsMarkup = '';
    const { hits, pageNumber, showMore, totalNumber } = data.results;
    const wlHits = queryFirst('.wishlist-hits');
    const noWlHits = queryFirst('.no-wishlist-hits');

    if (totalNumber > 0) {
        hits.forEach(function (hit) {
            const hitMarkup = `<div class="row wishlist-hit">
            <div class="col-4 wishlist-hit-cell">${hit.firstName}</div>
            <div class="col-4 wishlist-hit-cell">${hit.lastName}</div>
            <div class="col-4 wishlist-hit-cell">
            <a href="${hit.url}" title="${hit.urlTitle}" data-id="${hit.id}" class="text-underline">${hit.urlText}</a>
            </div></div>`;
            searchResultsMarkup += hitMarkup;
        });

        queryFirst('.wishlist-hits-body').innerHTML = searchResultsMarkup;
        addClass(noWlHits, hiddenClass);
        removeClass(wlHits, hiddenClass);
        const moreWLResults = queryFirst('.find-another-wishlist');
        if (showMore) {
            const moreWLResultsButton = queryFirst('.more-wishlist-results', moreWLResults);
            moreWLResultsButton.dataset.searchFname = document.getElementById('wishlist-search-first-name').value;
            moreWLResultsButton.dataset.searchLname = document.getElementById('wishlist-search-last-name').value;
            moreWLResultsButton.dataset.pageNumber = pageNumber;
            removeClass(moreWLResults, hiddenClass);
        }
        else {
            addClass(moreWLResults, hiddenClass);
        }

        $body.trigger('wishlist:search-results');
    }
    else {
        removeClass(noWlHits, hiddenClass);
        addClass(wlHits, hiddenClass);
        $body.trigger('wishlist:search-noresults');
    }
    removeClass(queryFirst('.wishlist-search-results'), hiddenClass);
    $.spinner().stop();
}

/**
 * renders the products of selected wishlist
 * @param {Object} selectedList - The selected list data
 * @param {boolean} isNewList - If new list is created
 */
function selectedListData(selectedList, isNewList) {
    const { actionUrl, uuid, href } = selectedList.dataset;
    const param = { id: uuid };
    const urlWithParam = appendToUrl(actionUrl, param);
    removeClass(queryAll('.wishlists-lists'), 'selected');
    addClass(selectedList, 'selected');
    history.replaceState({}, '', href);
    $.spinner().start();
    $.ajax({
        url: urlWithParam,
        type: 'get',
        dataType: 'html',
        success: function (data) {
            const wishlistDiv = queryFirst('.wishlist-product-tab');
            if (data) {
                wishlistDiv.innerHTML = data;
                const wishlistDetailsTab = queryFirst('.wishlist-details-tab');
                const wishlistSidebar = queryFirst('.wishlist-left-sidebar');
                const selectedListDiv = queryFirst('.wishlists-lists-' + uuid);
                const detailsTabItemCount = queryFirst('.header-items-count').textContent;
                const leftNavigationItemCount = queryFirst('.list-items-count', selectedListDiv);
                leftNavigationItemCount.textContent = detailsTabItemCount;
                if (!isNewList) {
                    addClass(wishlistSidebar, 'wishlist-left-mobile');
                    removeClass(wishlistDetailsTab, 'wishlist-right-mobile');
                    scrollTo($body.offset().top, 0);
                }
            }
            $.spinner().stop();
        },
        error: function (err) {
            $.spinner().stop();
        }
    });
}

export default {
    removeFromWishlist: function () {
        $wishlist.on('click', '.remove-from-wishlist', function (e) {
            e.preventDefault();
            const { target } = e;
            const { url, uuid, listId } = target.dataset;
            var elMyAccount = $('.account-wishlist-item').length;
            const selectedListClass = '.wishlists-lists-' + listId;
            const productListName = queryFirst(selectedListClass);
            const urlParams = { uuid: uuid, id: listId };
            const actionUrl = appendToUrl(url, urlParams);

            // If user is in my account page, call removeWishlistAccount() end point, re-render wishlist cards
            if (elMyAccount > 0) {
                $('.wishlist-account-card')
                    .spinner()
                    .start();
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'html',
                    data: {},
                    success: function (html) {
                        $('.wishlist-account-card>.card').remove();
                        $('.wishlist-account-card').append(html);
                        $('.wishlist-account-card').spinner().stop();
                    },
                    error: function () {
                        var $elToAppend = $('.wishlist-account-card');
                        $elToAppend.spinner().stop();
                        var msg = $elToAppend.data('error-msg');
                        displayErrorMessage($elToAppend, msg);
                    }
                });
                // else user is in wishlist landing page, call removeProduct() end point, then remove this card
            } else {
                $.spinner().start();
                $.ajax({
                    url: actionUrl,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        if (data.success) {
                            const listProductCount = queryFirst('.list-items-count', productListName);
                            const detailsItemCount = queryFirst('.header-items-count');
                            if (data.wishListCountMessage) {
                                listProductCount.textContent = data.wishListCountMessage;
                                detailsItemCount.textContent = data.wishListCountMessage;
                            }
                            if (isMcEnable === 'true') {
                                // update Marketing Cloud Analytics trackWishlist event
                                trackWishlist(data.marketingCloudAnalyticsData);
                            }
                            var pageNumber = $('.wishlistItemCardsData').data('page-number') - 1;
                            renderNewPageOfItems(pageNumber);
                        }
                        else {
                            $.spinner().stop();
                            const $elToAppendWL = $('.wishlistItemCardsDetails');
                            const $elErrorMsg = $('.wishlistItemCards');
                            const msg = $elErrorMsg.data('error-msg');
                            displayErrorMessage($elToAppendWL, msg);
                        }
                    },
                    error: function () {
                        $.spinner().stop();
                        var $elToAppendWL = $('.wishlistItemCards');
                        var msg = $elToAppendWL.data('error-msg');
                        displayErrorMessage($elToAppendWL, msg);
                    }
                });
            }
        });
    },

    viewProductViaEdit: function () {
        $body.on('click', '.edit-add-to-wishlist .edit', function (e) {
            e.preventDefault();

            var editProductUrl = $(this).attr('href');
            $(e.target).trigger('editwishlistproduct:show');
            getModalHtmlElement();
            fillModalElement(editProductUrl);
        });
    },

    viewProductViaSelectAttribute: function () {
        $body.on('click', '.select-attributes-btn', function (e) {
            e.preventDefault();

            var editProductUrl = $(this).data('get-product-url');
            getModalHtmlElement();
            fillModalElement(editProductUrl);
        });
    },

    focusEditWishlistProductModal: function () {
        $body.on('shown.bs.modal', '#editWishlistProductModal', function () {
            $('#editWishlistProductModal')
                .siblings()
                .attr('aria-hidden', 'true');
            $('#editWishlistProductModal .close').focus();
        });
    },

    onClosingEditWishlistProductModal: function () {
        $body.on(
            'hidden.bs.modal',
            '#editWishlistProductModal',
            function () {
                $('#editWishlistProductModal').remove();
                $('.modal-backdrop').remove();
                $body.removeClass('modal-open');

                $('#editWishlistProductModal')
                    .siblings()
                    .attr('aria-hidden', 'false');
            }
        );
    },

    trapEditWishlistProductModalFocus: function () {
        $body.on('keydown', '#editWishlistProductModal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#editWishlistProductModal',
                firstElementSelector: '.close',
                lastElementSelector: '.btn-update-wishlist-product',
                nextToLastElementSelector: '.select-size'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },

    updateWishlistUpdateButton: function () {
        $body.on('product:updateAddToCart', function (e, response) {
            response.$productContainer
                .find('.btn-update-wishlist-product')
                .attr(
                    'disabled',
                    !response.product.readyToOrder ||
                    !response.product.available
                );
        });
    },

    updateWishListItem: function () {
        $body.on('click', '.btn-update-wishlist-product', function (e) {
            e.preventDefault();

            var updateButtonBlock = $(this)
                .closest('.wishlist-item-update-button-block')
                .find('.update-wishlist-url');
            var updateProductUrl = updateButtonBlock.val();
            var uuid = updateButtonBlock.data('uuid');

            var form = {
                uuid: uuid,
                pid: base.getPidValue($(this))
            };

            $('#editWishlistProductModal')
                .spinner()
                .start();

            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function () {
                    $.spinner().start();
                    $('#editWishlistProductModal')
                        .spinner()
                        .stop();
                    $('#editWishlistProductModal').remove();
                    $('.modal-backdrop').remove();
                    $body.removeClass('modal-open');
                    var pageNumber =
                        $('.wishlistItemCardsData').data('page-number') - 1;
                    renderNewPageOfItems(
                        pageNumber,
                        '.product-info .edit-add-to-wishlist .edit:first'
                    );
                },
                error: function () {
                    var msg = $('.btn-update-wishlist-product').data(
                        'error-msg'
                    );

                    $('#editWishlistProductModal')
                        .spinner()
                        .stop();
                    $('#editWishlistProductModal').remove();
                    $('.modal-backdrop').remove();
                    $body.removeClass('modal-open');

                    if ($('.update-wishlist-messages').length === 0) {
                        $body.append(
                            '<div class="update-wishlist-messages "></div>'
                        );
                    }

                    $('.update-wishlist-messages').append(
                        '<div class="update-wishlist-alert text-center alert-danger">' +
                        msg +
                        '</div>'
                    );

                    setTimeout(function () {
                        $('.update-wishlist-messages').remove();
                    }, 5000);
                }
            });
        });
    },

    toggleWishlistStatus: function () {
        $wishlist.on('change', '.preferred-wishlist-setting', function (e) {
            const { target } = e;
            const { id } = target.dataset;
            var resetCheckBox = function () {
                return target.checked = !target.checked;
            };

            updatePublicStatus(id, null, resetCheckBox);
        });
    },

    toggleWishlistItemStatus: function () {
        $wishlist.on('change', '.wishlist-hide', function (e) {
            const { target } = e;
            const { id } = target.dataset;
            var resetCheckBox = function () {
                return target.checked = !target.checked;
            };

            updatePublicStatus(null, id, resetCheckBox);
        });
    },

    addToCartFromWishlist: function () {
        $wishlist.on('click', '.add-to-cart', function (e) {
            e.stopPropagation();
            const { target } = e;
            const wishlistCardItem = target.closest('.wishlist-card-item');
            const addToCartButtonEl = queryFirst('.add-to-cart', wishlistCardItem);

            if (queryFirst('.size-card', wishlistCardItem)) {
                toggleSelectSizeInfo(wishlistCardItem);

                if (!queryFirst('.quick-add-to-cart.selected', wishlistCardItem)) {
                    addToCartButtonEl.disabled = true;
                    return;
                }
            }

            $.spinner().start();
            $body.trigger('product:beforeAddToCart', this);
            let pidsQty;
            const { pid, url, uuid, wishlistId } = target.dataset;
            pidsQty = parseInt(
                $(this)
                    .closest('.product-info')
                    .find('.quantity')
                    .val(),
                10
            );

            const form = {
                pid,
                quantity: pidsQty,
                wishlistUUID: uuid,
                listID: wishlistId
            };

            if ($(this).data('option')) {
                form.options = JSON.stringify($(this).data('option'));
            }

            $(this).trigger('updateAddToCartFormData', form);
            if (url) {
                getJSON(url, 'POST', form, (data) => {
                    if (wishlistCardItem) {
                        const { removedWishListItem, wishListCountMessage, updatedWishListCount, itemsMsg, shopNewAsset } = data;
                        const selectedListDiv = queryFirst('.wishlists-lists-' + wishlistId);
                        const detailsTabItemCount = queryFirst('.header-items-count');
                        const listItemCount = queryFirst('.list-items-count', selectedListDiv);
                        if (removedWishListItem) {
                            detailsTabItemCount.textContent = updatedWishListCount + ' ' + itemsMsg;
                            listItemCount.textContent = updatedWishListCount + ' ' + itemsMsg;
                            wishlistCardItem.remove();
                            if (updatedWishListCount < 1) {
                                const emptyWishlistMarkup = guestEmptyWishlistTemplate(wishListCountMessage, shopNewAsset);
                                const wishlistCardItems = queryFirst('.wishlistItemCards');
                                if (wishlistCardItems) {
                                    wishlistCardItems.outerHTML = emptyWishlistMarkup;
                                }
                            }
                        }
                    }
                    handlePostCartAdd(data);
                    $body.trigger('product:afterAddToCart', data);
                    $.spinner().stop();
                }, () => {
                    $.spinner().stop();
                });
            }
        });
    },
    notifyMeEmailValidator: function () {
        $wishlist.on('blur', '.notify-email', e => {
            const { target } = e;
            const { value } = target;
            const emailFormGroup = target.closest('.form-group');
            const emailError = queryFirst('.email-error', emailFormGroup);
            const { missingError, patternMismatch } = target.dataset;
            if (!value) {
                addClass(target, invalidClass);
                emailError.textContent = missingError;
            } else if (target.checkValidity && !target.checkValidity()) {
                addClass(target, invalidClass);
                emailError.textContent = patternMismatch;
            } else {
                removeClass(target, invalidClass);
            }
        });
    },
    notifyMeSubmitHandler: function () {
        $wishlist.on('submit', '.notify-form', e => {
            e.preventDefault();
            const { target } = e;
            const { selectedWishListCardId } = target.dataset;
            const actionUrl = target.getAttribute('action');
            const data = {
                productID: document.getElementById('notify-sku').value,
                email: queryFirst('.notify-email').value,
                fromWishlistPage: true
            };
            $('#notifyMe').spinner().start();
            getJSON(actionUrl, 'POST', data, (data) => {
                const confirmMessage = data.message;
                const selectedWishListCard = document.getElementById(selectedWishListCardId);
                queryFirst('.wishlist-notify-me-desc', selectedWishListCard).textContent = confirmMessage;
                queryFirst('.wishlist-notify-me-btn', selectedWishListCard).disabled = true;
                $('#notifyMe').modal('hide');
            }, () => {
                $.spinner().stop();
            });
        });
    },
    moreWLItems: function () {
        $wishlist.on('click', '.more-wishlist-items', e => {
            const { target } = e;
            const { pageNumber } = target.dataset;
            $.spinner().start();
            renderNewPageOfItems(pageNumber);
        });

        $wishlist.on('change', '.pagination-wishlist', function () {
            const selectedOption = this.options[this.selectedIndex];
            const { pageNumber } = selectedOption.dataset;
            $.spinner().start();
            renderNewPageOfItems(pageNumber);
        });
    },
    copyWishlistLink: function () {
        $body.on('click', '.fa-link', function () {
            var $temp = $('<input>');
            $body.append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },
    submitWishlistSearch: function () {
        $wishlist.on('submit', '#wishlist-search', function (e) {
            e.preventDefault();
            var firstName = $('#wishlist-search-first-name').val();
            var lastName = $('#wishlist-search-last-name').val();
            var email = $('#wishlist-search-email').val();

            if (
                (!firstName && !lastName && !email) ||
                (firstName && !lastName && !email) ||
                (!firstName && lastName && !email)
            ) {
                $('.wishlist-error-search div').addClass('alert alert-danger');
                var errorText = $('.wishlist-error-search').data('error-msg');
                $('.wishlist-error-search div').html(errorText);
            } else {
                const data = {
                    searchFirstName: firstName,
                    searchLastName: lastName,
                    searchEmail: email
                };
                const { actionUrl } = queryFirst('.button-wishlist-search').dataset;
                queryFirst('.wishlist-error-search div').textContent = '';
                $.spinner().start();
                getJSON(actionUrl, 'GET', data, handleSearchResults, () => {
                    $.spinner().stop();
                });
            }
        });
    },
    moreWLSearchResults: function () {
        $wishlist.on('click', '.more-wishlist-results', function () {
            var firstName = $(this).data('search-fname');
            var lastName = $(this).data('search-lname');
            var pageNumber = $(this).data('page-number');
            var uuids = [];
            $('.wishlist-hit').each(function () {
                uuids.push(
                    $(this)
                        .find('a')
                        .data('id')
                );
            });
            var url = $(this).data('url');
            $.spinner().start();
            $.ajax({
                url: url,
                method: 'POST',
                data: {
                    firstName: firstName,
                    lastName: lastName,
                    uuids: JSON.stringify(uuids),
                    pageNumber: ++pageNumber
                },
                success: function (data) {
                    const { changedList, totalString, hits, showMore, pageNumber } = data.results;
                    if (changedList) {
                        $('.wishlist-hits .wishlist-hit').remove();
                    }
                    $('#result-count').html(totalString);
                    hits.forEach(function (hit) {
                        const hitMarkup = `<div class="row wishlist-hit">
                        <div class="col-4 wishlist-hit-cell">${hit.firstName}</div>
                        <div class="col-4 wishlist-hit-cell">${hit.lastName}</div>
                        <div class="col-4 wishlist-hit-cell">
                        <a href="${hit.url}" title="${hit.urlTitle}" data-id="${hit.id}">${hit.urlText}</a>
                        </div></div>`;
                        $('.wishlist-hits-body').append(hitMarkup);
                    });
                    const findAnotherWishlist = $('.find-another-wishlist .more-wishlist-results');
                    if (showMore) {
                        findAnotherWishlist.data('page-number', pageNumber);
                    } else {
                        findAnotherWishlist.remove();
                    }
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    selectSizeAttribute: function () {
        $wishlist.on('click', '.size-btn', function (e) {
            e.preventDefault();
            const sizeButtonEl = this;
            
            if (!hasClass(sizeButtonEl, 'selected')) {
                $.spinner().start();
                const selectedSizeId = sizeButtonEl.dataset.attrValue;
                const wishListContainer = sizeButtonEl.closest('.wishlist-card-item');
                const addToCartButtonEl = queryFirst('.add-to-cart', wishListContainer);
                const selectSizeMessageEl = queryFirst('.select-size-message', wishListContainer);
                if (selectedSizeId) {
                    addClass(sizeButtonEl, 'selected');
                    selectSizeMessageEl.innerHTML = '';
                    addToCartButtonEl.disabled = false;
                }
                wishListAttributeSelect(sizeButtonEl.dataset.attrUrl, $(wishListContainer), sizeButtonEl);
            }
        });
    },
    handleSizeChange: function () {
        $body.on('product:afterAttributeSelect', (event, response) => {
            const { product } = response.data;
            const { available, stockNotifyEnable, allowStockNotification, id, readyToOrder, online, forceOutOfStock, isDirectlyPurchasable, earlyAccess, availability } = product;
            const wishlistCardElement = response.container[0];
            const { selectedSizeElement } = response;
            const offsetMd5Class = 'offset-md-5';
            const justifyContentStart = 'justify-content-start';
            const outOfStockImageClass = 'out-of-stock-img';
            const isLoyaltyHeaderProfile = getNestedValue(window, 'johnnyWasUtils.profile') || {};
            const { isLoyaltyProgramMember, isLoyaltyEnabled } = isLoyaltyHeaderProfile;
            const loyaltyEarlyAccessLockEl = queryFirst('.loyalty-early-access-lock-container', wishlistCardElement);
            if (isLoyaltyEnabled && loyaltyEarlyAccessLockEl && earlyAccess && earlyAccess.isEarlyAccessProduct) {
                if (isLoyaltyProgramMember) {
                    addClass(loyaltyEarlyAccessLockEl, hiddenClass);
                } else {
                    removeClass(loyaltyEarlyAccessLockEl, hiddenClass);
                }
            }
            removeClass(queryAll('.size-btn', wishlistCardElement), selectedClass);
            addClass(selectedSizeElement, selectedClass);
            queryFirst('.wishlist-sku', wishlistCardElement).textContent = id;
            const sizeCard = selectedSizeElement.closest('.size-card');
            const selectedSize = queryFirst('.selected-size', sizeCard);
            selectedSize.textContent = selectedSizeElement.dataset.attrValue;
            removeClass(queryFirst('.size-seperator', sizeCard), hiddenClass);
            removeClass(selectedSize, hiddenClass);
            const sizeContainer = selectedSizeElement.closest('.size-container');
            const assistiveElements = queryAll('.selected-assistive-text', sizeContainer);
            assistiveElements.forEach(eachElement => {
                if (eachElement.textContent.includes(eachElement.dataset.outOfStock)) {
                    eachElement.textContent = eachElement.dataset.outOfStock;
                } else {
                    eachElement.textContent = '';
                }
            });
            const assistiveElementOfSelected = queryFirst('.selected-assistive-text', selectedSizeElement.closest('.size-list'));
            const { selectedText, outOfStock } = assistiveElementOfSelected.dataset;
            assistiveElementOfSelected.textContent = selectedText;
            if (hasClass(selectedSizeElement, 'not-available')) {
                assistiveElementOfSelected.textContent += ' ' + outOfStock;
            }
            const addToCartButton = queryFirst('.add-to-cart', wishlistCardElement);
            const removeButton = queryFirst('.remove-from-wishlist', wishlistCardElement);
            const notifyMeButton = queryFirst('.wishlist-notify-me-btn', wishlistCardElement);
            const notifyMeDesc = queryFirst('.wishlist-notify-me-desc', wishlistCardElement);
            const wishlistItemImage = queryFirst('.product-image', wishlistCardElement);
            const availabilitySection = queryFirst('.wishlist-item-availability', wishlistCardElement);
            const outOfStockMessage = queryFirst('.out-of-stock-message', wishlistCardElement);
            const notAvailableMessage = queryFirst('.not-available-message', wishlistCardElement);
            const notPurchasableMessage = queryFirst('.not-purchasable-message', wishlistCardElement);
            const productInfo = queryFirst('.product-info', wishlistCardElement);
            const isGlobaleSession = productInfo ? productInfo.dataset.isglobalesession : false;
            addToCartButton.disabled = !product.readyToOrder || !product.available || isDirectlyPurchasable === false;
            addClass(notPurchasableMessage, hiddenClass);
            if (isDirectlyPurchasable === false) {
                addClass(wishlistItemImage, outOfStockImageClass);
                removeClass([addToCartButton, availabilitySection, notPurchasableMessage], hiddenClass);
                addClass([notifyMeButton, notifyMeDesc, notAvailableMessage, outOfStockMessage], hiddenClass);
                removeClass(removeButton, offsetMd5Class, justifyContentStart);
            } else if (isGlobaleSession === 'true' && availability.isPreOrder) {
                removeClass([availabilitySection, outOfStockMessage], hiddenClass);
                removeClass(removeButton, offsetMd5Class, justifyContentStart);
                addClass(wishlistItemImage, outOfStockImageClass);
                if (stockNotifyEnable && allowStockNotification && !forceOutOfStock) {
                    notifyMeButton.dataset.pid = id;
                    removeClass([notifyMeButton, notifyMeDesc], hiddenClass);
                    addClass(addToCartButton, hiddenClass);
                } else {
                    addClass([notifyMeButton, notifyMeDesc], hiddenClass);
                    removeClass(addToCartButton, hiddenClass);
                }
            } else if (readyToOrder && available) {
                addToCartButton.dataset.pid = product.id;
                addClass([notifyMeButton, notifyMeDesc, availabilitySection, notAvailableMessage, outOfStockMessage], hiddenClass);
                removeClass(wishlistItemImage, outOfStockImageClass);
                removeClass(removeButton, offsetMd5Class, justifyContentStart);
                removeClass(addToCartButton, hiddenClass);
            } else if (online && !available) {
                removeClass([availabilitySection, outOfStockMessage], hiddenClass);
                removeClass(removeButton, offsetMd5Class, justifyContentStart);
                addClass(wishlistItemImage, outOfStockImageClass);
                if (stockNotifyEnable && allowStockNotification && !forceOutOfStock) {
                    notifyMeButton.dataset.pid = id;
                    removeClass([notifyMeButton, notifyMeDesc], hiddenClass);
                    addClass(addToCartButton, hiddenClass);
                } else {
                    addClass([notifyMeButton, notifyMeDesc], hiddenClass);
                    removeClass(addToCartButton, hiddenClass);
                }
            } else {
                addClass([addToCartButton, outOfStockMessage], hiddenClass);
                addClass(removeButton, offsetMd5Class, justifyContentStart);
                addClass(wishlistItemImage, outOfStockImageClass);
                removeClass([availabilitySection, notAvailableMessage], hiddenClass);
            }
            notifyMeButton.disabled = false;
            $.spinner().stop();
        });
    },
    setNotifyMeProductDetails: function () {
        $wishlist.on('click', '.wishlist-notify-me-btn', function (e) {
            const wishlistCardItem = e.target.closest('.wishlist-card-item');
            const notifyContainer = queryFirst('.notify-me-container');
            const wishlistItemImage = queryFirst('.wishlist-item-image .product-image', wishlistCardItem);
            const notifyImageElement = queryFirst('.notify-product-img', notifyContainer);
            const notifyImageElementMarkup = `<img src="${wishlistItemImage.getAttribute('src')}" srcset="${wishlistItemImage.getAttribute('srcset')}"
            alt="${wishlistItemImage.getAttribute('alt')}" title="${wishlistItemImage.getAttribute('title')}" />`
            notifyImageElement.innerHTML = notifyImageElementMarkup;
            const wishlistProductName = queryFirst('.wishlist-item-name', wishlistCardItem).textContent;
            queryFirst('.notify-product-name', notifyContainer).textContent = wishlistProductName;
            const wishlistProductPrice = queryFirst('.price-section .sales .value', wishlistCardItem).innerText;
            queryFirst('.notify-price', notifyContainer).textContent = wishlistProductPrice;
            queryFirst('.notify-me-product-attributes', notifyContainer).innerHTML = queryFirst('.wishlist-item-details .wishlist-item-attributes', wishlistCardItem).innerHTML;
            const { isVariationGroup, pid } = e.target.dataset;
            const notifySize = queryFirst('.notify-size', notifyContainer);
            if (isVariationGroup === 'true') {
                queryFirst('.size-label', notifySize).textContent = queryFirst('.size-display-name', wishlistCardItem).value;
                queryFirst('.selected-size', notifySize).textContent = queryFirst('.size-card .size-btn.selected').dataset.attrValue;
                removeClass(notifySize, hiddenClass);
            }
            else {
                addClass(notifySize, hiddenClass);
            }
            if (pid) {
                document.getElementById('notify-sku').value = pid;
            }
            const custEmail = (document.getElementById('notifyEmail') || {}).value;
            if (custEmail) {
                queryFirst('.notify-email', notifyContainer).value = custEmail;
            }
            const notifyMeSubmit = queryFirst('.notify-form', notifyContainer);
            notifyMeSubmit.dataset.selectedWishListCardId = wishlistCardItem.getAttribute('id');
            notifyMeSubmit.dataset.masterId = queryFirst('.product-info', wishlistCardItem).dataset.masterid;
        });
    },
    wishlistSearchInputValidator: function () {
        $wishlist.on('keyup', '#wishlist-search-first-name, #wishlist-search-last-name', (event) => {
            const { target } = event;
            const { value } = target;
            const regExp = /^[a-zA-Z]+(([ ][a-zA-Z ])?[a-zA-Z]*)*$/;
            if (value && !regExp.test(value)) {
                const invalidFeedbackEl = queryFirst('.invalid-feedback', target.closest('.form-group'));
                if (invalidFeedbackEl) {
                    addClass(target, invalidClass);
                    invalidFeedbackEl.textContent = target.dataset.patternMismatch;
                }
            } else {
                removeClass(target, invalidClass);
            }
        });
    },
    wishlistSearchEmailValidator: function () {
        $wishlist.on('keyup', '#wishlist-search-email', (event) => {
            const { target } = event;
            const { value } = target;
            const invalidFeedbackEl = queryFirst('.invalid-feedback', target.closest('.form-group'));
            if (value && target.checkValidity && !target.checkValidity() && invalidFeedbackEl) {
                addClass(target, invalidClass);
                invalidFeedbackEl.textContent = target.dataset.patternMismatch;
            } else {
                removeClass(target, invalidClass);
            }
        });
    },
    handleWishlistsModalAction: function () {
        $wishlist.on('click', '.create-wishlist-btn-main, .edit-list-name-link, .share-list', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const { target } = e;
            let dialog;
            if (hasClass(target, 'edit-list-name')) {
                const { uuid, wishlistName } = target.dataset;
                const editListNameInput = queryFirst('.list-name-field .edit-list-name-input');
                dialog = $(editWishlistDialog);
                queryFirst('.edit-list-header').textContent = wishlistName;
                editListNameInput.value = wishlistName;
                queryAll('.update-list-name-btn, .delete-list-btn').forEach(eachEl => {
                    eachEl.dataset.uuid = uuid;
                });
                removeClass(editListNameInput, invalidClass);
                addClass(deleteWishlistDialogContent, hiddenClass);
                removeClass(editWishlistDialogContent, hiddenClass);
            }
            else if (hasClass(target, 'create-wishlist-btn-main')) {
                dialog = $(createWishlistDialog);
                const listNameInput = queryFirst('#list-name');
                const addNewListbutton = queryFirst('.add-new-list');
                listNameInput.value = '';
                removeClass(listNameInput, invalidClass);
                addNewListbutton.disabled = true;
                listNameInput.addEventListener('input', function (event) {
                    const listNameTrimText = listNameInput && listNameInput.value && listNameInput.value.trim();
                    addNewListbutton.disabled = !listNameTrimText.length;

                });
            }
            else if (hasClass(target, 'share-list')) {
                const { shareUrl } = target.dataset;
                queryFirst('.share-wishlist-dialog .share-list-link').value = shareUrl;
                dialog = $(shareWishlistDialog);
            }
            if (!dialog.length) return;

            dialog.modal('show');
        });
    },
    handleBackToWishlistMain: function () {
        $wishlist.on('click', '.back-to-sidebar', function (e) {
            const wishlistDetailsTab = queryFirst('.wishlist-details-tab');
            const wishlistSidebar = queryFirst('.wishlist-left-sidebar');
            history.replaceState({}, '', location.href.split('?')[0]);
            addClass(wishlistDetailsTab, 'wishlist-right-mobile');
            removeClass(wishlistSidebar, 'wishlist-left-mobile');
        });
    },
    deleteWishlist: function () {
        $(editWishlistDialog).on('click', '.delete-list-btn-popup', function (e) {
            e.preventDefault();
            addClass(editWishlistDialogContent, hiddenClass);
            removeClass(deleteWishlistDialogContent, hiddenClass);
        });
        $(editWishlistDialog).on('click', '.delete-list-btn', function (event) {
            event.preventDefault();
            const { actionUrl, uuid } = this.dataset;
            $.spinner().start();
            $.ajax({
                url: actionUrl,
                type: 'post',
                dataType: 'json',
                data: {
                    id: uuid
                },
                success: function (data) {
                    if (data.success) {
                        const selectedList = queryFirst('.wishlists-lists.selected').dataset.uuid;
                        if (selectedList === uuid) {
                            history.replaceState({}, '', location.href.split('?')[0]);
                        }
                        location.reload();
                    } else {
                        $.spinner().stop();
                        $(editWishlistDialog).modal('hide');
                    }
                },
                error: function (err) {
                    $(editWishlistDialog).modal('hide');
                    $.spinner().stop();
                }
            });
        });
    },
    updateListCollection: function () {
        $(createWishlistDialog).on('submit', function (e) {
            e.preventDefault();
            const button = queryFirst('.add-new-list', this);
            const url = button.dataset.href;
            const listNameInput = queryFirst('#list-name', this);
            const invalidFeedback = queryFirst('.create-wishlist-dialog .invalid-feedback');
            let listName = listNameInput.value && listNameInput.value.trim();

            if (listName && !WISHLIST_NAME_REGEX.test(listName)) {
                if (invalidFeedback) {
                    addClass(listNameInput, invalidClass);
                    invalidFeedback.textContent = listNameInput.dataset.patternMismatch;
                }
            }
            else {
                removeClass(listNameInput, invalidClass);
                listName = listName.replace(/\s\s+/g, ' ');
                $.spinner().start();
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: {
                        wishlistName: listName
                    },
                    success: function (data) {
                        $.spinner().stop();
                        if (data.success) {
                            const listCollectionDiv = queryFirst('.wishlist-left-navigation-bar');
                            $(createWishlistDialog).modal('hide');
                            listCollectionDiv.innerHTML = data.wishlistCollectionsHtml;
                            const selectedListCard = queryFirst('.wishlists-lists-' + data.wishListUUID);
                            selectedListData(selectedListCard, true);
                            $body.trigger('wishlist:createsuccess');
                            const wishlistCollectionBar = queryFirst('.wishlist-section.wishlist-left-sidebar');
                            scrollTo(wishlistCollectionBar.getBoundingClientRect().top, 0);
                        }
                        else {
                            invalidFeedback.textContent = data.msg;
                            addClass(listNameInput, invalidClass);
                            $body.trigger('wishlist:createfail');
                        }
                    },
                    error: function (err) {
                        $.spinner().stop();
                        $(createWishlistDialog).modal('hide');
                    }
                });
            }
        });
        $(editWishlistDialog).on('submit', function (event) {
            event.preventDefault();
            const invalidFeedback = queryFirst('.edit-wishlist-dialog .invalid-feedback');
            const updateListNameButton = queryFirst('.update-list-name-btn', this);
            const { actionUrl, uuid } = updateListNameButton.dataset;
            const listNameInput = queryFirst('#list-name-input', editWishlistDialog);
            let listNameValue = listNameInput.value;
            const listNameTrimText = listNameInput && listNameValue && listNameValue.trim();
            if (!listNameTrimText.length || (listNameValue && !WISHLIST_NAME_REGEX.test(listNameValue))) {
                if (invalidFeedback) {
                    addClass(listNameInput, invalidClass);
                    if (!listNameTrimText.length) {
                        invalidFeedback.textContent = listNameInput.dataset.errorMsg;
                    }
                    else {
                        invalidFeedback.textContent = listNameInput.dataset.patternMismatch;
                    }
                }
            }
            else {
                removeClass(listNameInput, invalidClass);
                listNameValue = listNameTrimText.replace(/\s\s+/g, ' ');
                $.ajax({
                    url: actionUrl,
                    type: 'post',
                    dataType: 'json',
                    data: {
                        id: uuid,
                        wishlistName: listNameValue
                    },
                    success: function (data) {
                        $.spinner().stop();
                        if (data.success) {
                            window.location.reload();

                        } else {
                            invalidFeedback.textContent = data.msg;
                            addClass(listNameInput, invalidClass);
                        }
                    },
                    error: function (err) {
                        $.spinner().stop();
                    }
                });
            }
        });
    },
    copyShareLink: function () {
        $('#shareWishlistDialog').on('click', '.copy-share-link-btn', function (e) {
            const copyShareLinkText = queryFirst('.share-list-link', shareWishlistDialog);
            copyShareLinkText.select();
            copyShareLinkText.setSelectionRange(0, 99999); /* For mobile devices */

            /* Copy the text */
            navigator.clipboard.writeText(copyShareLinkText.value);
            $('#shareWishlistDialog').modal('hide');
        });
    },
    selectedList: function () {
        $wishlist.on('click', '.wishlists-lists', function (e) {
            e.preventDefault();
            selectedListData(this, false);
            $body.trigger('wishlist:viewselected');
        });
    },
    updateFitSizeTab: updateFitSizeTab
};
